export default __webpack_public_path__ + "static/media/Moti-Masjid.4e94c624.jpg";